import React from 'react';
import { IoServer, IoShieldCheckmark, IoLockClosed } from 'react-icons/io5';
import AnimatedSection from '../ui/AnimatedSection';
import AnimatedCard from '../ui/AnimatedCard';

const BusinessFeatures = () => {
  const features = [
    {
      icon: <IoServer className="text-5xl" />,
      title: "Self-hosting",
      description: "Our products can be self-hosted for complete control and data sovereignty.",
      cta: "Book a call to see it in action"
    },
    {
      icon: <IoLockClosed className="text-5xl" />,
      title: "Single Sign-On",
      description: "All our products support integrating Single Sign-On (SSO) for seamless access.",
      cta: "Book a call to see it in action"
    },
    {
      icon: <IoShieldCheckmark className="text-5xl" />,
      title: "Security & Compliance",
      description: "Clear indicators of compliance issues. Interact with any vendor with confidence.",
      cta: "Book a call to see it in action"
    }
  ];

  return (
    <section id="business-features" className="py-20 dark-section relative">
      <div className="container mx-auto px-4 relative z-10">
        <AnimatedSection>
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">For Business</h2>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto">
              Empower your organization with the technology to adapt and thrive in an ever-changing world.
            </p>
          </div>
        </AnimatedSection>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-12">
          {features.map((feature, index) => (
            <AnimatedCard key={index} index={index}>
              <div className="dark-card rounded-xl transition-all duration-300 p-8 h-full flex flex-col relative z-10">
                <div className="mb-6 text-blue-400 transform group-hover:scale-110 transition-transform duration-300">
                  {feature.icon}
                </div>
                <h3 className="text-2xl font-bold mb-4 text-white">{feature.title}</h3>
                <p className="text-gray-300 mb-6 flex-grow leading-relaxed">{feature.description}</p>
                <a
                  href="#contact"
                  className="text-blue-400 hover:text-blue-300 font-semibold inline-flex items-center"
                >
                  {feature.cta} →
                </a>
              </div>
            </AnimatedCard>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BusinessFeatures;

